import { useState } from "react";
import { toast } from "sonner";
import { Sun, Moon, MonitorSmartphone, Check } from "lucide-react";
import { Auth } from "@/lib/api";
import { getThemePref, setThemePref } from "@/lib/theme";

const OPTIONS = [
  ["light", "Claro", "Branco-pérola com acentos neon suaves", Sun],
  ["dark", "Escuro", "Azul-noite com neon subtil (original)", Moon],
  ["auto", "Automático", "Segue a preferência do dispositivo", MonitorSmartphone],
];

// Definições → Aparência: guarda no dispositivo e no perfil do utilizador.
export default function AppearancePanel() {
  const [pref, setPref] = useState(getThemePref);
  const choose = async (v) => {
    setPref(v);
    setThemePref(v);
    try { await Auth.updateSettings({ theme: v }); } catch { toast.error("Tema aplicado neste dispositivo, mas não foi possível guardá-lo no perfil."); }
  };
  return (
    <div className="rounded-2xl border border-slate-800 bg-slate-900/50 p-6 space-y-4" data-testid="appearance-panel">
      <div>
        <div className="font-display text-lg text-slate-50">Aparência</div>
        <p className="text-sm text-slate-400 mt-1">Aplica-se a todas as páginas profissionais. O Portal do Paciente tem o seu próprio seletor de tema, escolhido pelo paciente.</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        {OPTIONS.map(([v, label, desc, Icon]) => (
          <button key={v} type="button" onClick={() => choose(v)} data-testid={`theme-option-${v}`} aria-pressed={pref === v}
            className={`text-left rounded-xl border p-4 transition-colors ${pref === v ? "border-sky-500/60 bg-sky-500/10 glow-sky" : "border-slate-800 hover:border-slate-600"}`}>
            <div className="flex items-center justify-between">
              <Icon className="w-5 h-5 text-sky-400" strokeWidth={1.5} />
              {pref === v && <Check className="w-4 h-4 text-sky-300" />}
            </div>
            <div className="mt-3 text-sm font-medium text-slate-100">{label}</div>
            <div className="text-xs text-slate-500 mt-0.5">{desc}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
